import {
    addMethod,
    boolean,
    ref,
    setLocale,
    string,
    type LocaleObject,
    type StringSchema,
} from 'yup';

const EMAIL_REGEX =
    /^(([^<>/()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*))@((\[?[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\]?)|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/g;

const translatedKeys: LocaleObject = {
    mixed: {
        required: 'atp.error.validation.common.required',
    },
    array: {
        min(params) {
            return {
                key: 'atp.error.validation.common.array.min',
                params,
                placeholders: {
                    min: params.min,
                },
            };
        },
        max(params) {
            return {
                key: 'atp.error.validation.common.array.max',
                params,
                placeholders: {
                    max: params.max,
                },
            };
        },
    },
    string: {
        min(params) {
            return {
                key: 'atp.error.validation.common.string.min',
                params,
                placeholders: {
                    min: params.min,
                },
            };
        },
        max(params) {
            return {
                key: 'atp.error.validation.common.string.max',
                params,
                placeholders: {
                    max: params.max,
                },
            };
        },
    },
};

setLocale(translatedKeys);

addMethod<StringSchema>(
    string,
    'hasLowerCase',
    function (message = 'atp.error.validation.common.lower_case') {
        return this.test('hasLowerCaseTest', message, function (this, value) {
            if (!value) return;
            return /[a-z]/.test(value);
        });
    }
);

addMethod<StringSchema>(
    string,
    'hasUpperCase',
    function (message = 'atp.error.validation.common.upper_case') {
        return this.test('hasUpperCaseTest', message, function (this, value) {
            if (!value) return;
            return /[A-Z]/.test(value);
        });
    }
);

addMethod<StringSchema>(
    string,
    'hasNumber',
    function (message = 'atp.error.validation.common.number') {
        return this.test('hasNumberTest', message, function (this, value) {
            if (!value) return;
            return /[0-9]/.test(value);
        });
    }
);

addMethod<StringSchema>(
    string,
    'hasSymbol',
    function (message = 'atp.error.validation.common.symbol') {
        return this.test('hasSymbolTest', message, function (this, value) {
            if (!value) return;
            return /["!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~"]/.test(value);
        });
    }
);

addMethod<StringSchema>(
    string,
    'isEmailValid',
    function (message = 'atp.error.validation.common.email.required') {
        return this.matches(EMAIL_REGEX, message);
    }
);

const localeCodes = availableLocales.map(({ code }) => code);

export const getLocaleSelectRule = (
    error = 'atp.error.validation.common.required',
    locales = localeCodes
) => {
    // !todo: change error key for invalid value provided
    return string().required().oneOf(locales, error);
};

export const getCheckboxRequiredRule = (
    errorKey = 'atp.error.validation.common.required',
    defaultValue = false
) => {
    return boolean().oneOf([true], errorKey).default(defaultValue);
};

export const getRepeatPasswordFieldRule = (
    passwordFieldName = 'password',
    errorKey = 'atp.error.validation.common.password.not_match'
) => {
    return string()
        .required()
        .oneOf([ref(passwordFieldName)], errorKey);
};

export const getPasswordFieldRule = () => {
    return string()
        .required()
        .min(8)
        .max(64)
        .hasLowerCase()
        .hasUpperCase()
        .hasNumber();
};

export * from 'yup';
